import { useMemo, useState } from 'react'
import { Trans } from 'react-i18next'
import { t } from 'i18next'

import {
  Button,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalHeading,
  ModalDismiss,
  ModalContent,
  Checkbox
} from '@vtex/shoreline'

import { MIN_CAMPAIGN_PERIOD_DAYS } from '~/modules/retailMedia/constants/objectiveBased'
import Tooltip from '~/components/Tooltip'

import { DataLine } from './DataLine'
import * as S from './styles'
import { getModalData } from './getModalDataProps'

export const ObjectiveBasedConfirmationModal = ({
  isModalOpen,
  setIsModalOpen,
  formRef,
  isLoading,
  selectedProducts
}: ObjectiveBasedConfirmationModalProps) => {
  const [isChecked, setIsChecked] = useState(false)
  const modalData = getModalData({ formRef, selectedProducts })

  const ButtonCreateCampaign = useMemo(
    () => (
      <Button
        variant="primary"
        size="large"
        type="submit"
        loading={isLoading}
        disabled={!isChecked || isLoading}
        onClick={() => formRef.current?.submitForm()}
      >
        {t('rm:createCampaign')}
      </Button>
    ),
    [isChecked, isLoading, formRef]
  )

  return (
    <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
      <ModalHeader>
        <ModalHeading>{t('rm:reviewCampaign')}</ModalHeading>
        <ModalDismiss />
      </ModalHeader>
      <ModalContent>
        <div>
          {modalData?.map(({ label, value }) => (
            <DataLine key={label} label={label} value={value} />
          ))}
        </div>
        <S.CheckboxContainer>
          <Checkbox
            checked={isChecked}
            onChange={() => setIsChecked(!isChecked)}
          >
            <Trans
              components={{ br: <br /> }}
              i18nKey="rm:objectiveBased.confirmationModal.termsAgreement"
              values={{
                days: MIN_CAMPAIGN_PERIOD_DAYS
              }}
            />
          </Checkbox>
        </S.CheckboxContainer>
      </ModalContent>

      <ModalFooter>
        <Button size="large" onClick={() => setIsModalOpen(false)}>
          {t('rm:button.Cancel')}
        </Button>
        {!isChecked ? (
          <Tooltip
            noMargin
            interactiveTrigger
            text={t(
              'rm:objectiveBased.confirmationModal.createCampaign.tooltip'
            )}
          >
            {ButtonCreateCampaign}
          </Tooltip>
        ) : (
          ButtonCreateCampaign
        )}
      </ModalFooter>
    </Modal>
  )
}
